import type { ChatParticipant } from './chat'

export interface Person {
  id: string
  name: Name[]
}

export interface Name {
  given?: string[]
  family?: string[]
  suffix?: string[]
}

export function getName (person: Person): string {
  // TODO: Fix
  if (!person) {
    return 'N/A'
  }

  return [
    person.name[0]?.given?.[0],
    person.name[0]?.family?.[0]
  ]
    .filter(Boolean)
    .join(' ')
}

export function getInitials (person: ChatParticipant | Person): string {
  let firstName = ''
  let lastName = ''

  if ('type' in person) {
    const parts = person.name.split(' ')
    firstName = parts[0] ?? ''
    lastName = parts[1] ?? ''
  } else {
    firstName = (person.name[0]?.given ?? []).filter(Boolean).join(' ')
    lastName = (person.name[0]?.family ?? []).filter(Boolean).join(' ')
  }

  let result: string

  switch (true) {
    case firstName.length > 0 && lastName.length > 0:
      result = [ firstName.substring(0, 1), lastName.substring(0, 1) ].join('')
      break

    case firstName.length > 0:
      result = firstName.substring(0, 2)
      break

    case lastName.length > 0:
      result = lastName.substring(0, 2)
      break

    default:
      result = person.id.substring(0, 2)
      break
  }

  return result.toUpperCase()
}
